<template>
  <v-snackbar
    v-model="show"
    bottom
    multi-line
    right
    auto-height
    vertical
    :timeout="timeout"
    :color="color"
    style="white-space: pre;"
  >
    <h6 v-if="title">{{ title }}</h6>
    {{ message }}
    <v-layout row>
      <v-btn flat color="white" v-if="showHelp" to="/help">Help</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="white" @click.native="show = false">Close</v-btn>
    </v-layout>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      showHelp: false,
      message: '',
      title: null,
      color: null,
      timeout: 6000,
      deep_link: null
    }
  },
  created: function() {
    this.$store.watch(
      state => state.root.notification,
      () => {
        const msg = this.$store.state.root.notification
        console.log('Message in Notification', msg)
        if (msg !== '') {
          this.show = true
          this.title = msg.title ? msg.title : null
          this.message = msg.message ? msg.message : msg
          this.deep_link = msg.deep_link ? msg.deep_link : null
          this.color = msg.color ? msg.color : ''
          this.timeout = msg.timeout ? msg.timeout : 6000
          this.showHelp = msg.showHelp ? msg.showHelp : false
          this.$store.commit('root/SET_NOTIFICATION', '')
        }
      }
    )
  }
}
</script>
